import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CardContent, CardHeader, Card as InterstateCard } from '@interstate/components/Card';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import * as offerReduxActionCreators from '@makemydeal/dr-dash-store/actions/offerRedux';
import { dealLockHooks } from '@makemydeal/dr-dash-components';
import { LoadingSectionParent } from '@makemydeal/dr-shared-components';
import { Typography } from '@interstate/components/Typography';
import { TextArea } from '@interstate/components/TextArea';

export const OfferCommentsInterstate = ({
    title = 'Offer Notes',
    description,
    textRows = 5
}: {
    textRows?: number;
    title?: string;
    description?: string;
}) => {
    const [comment, setComment] = useState('');
    const dispatch = useDispatch();
    const isEnableDealerCommentsEnabled = useSelector(featureToggleSelectors.isEnableDealerCommentsEnabled);
    const isLocked = dealLockHooks.useIsDealLocked();
    const handleCommentsChanged = (e: any) => {
        setComment(e.target.value);
        dispatch(offerReduxActionCreators.updatedShopperMessage(e.target.value));
        if (isEnableDealerCommentsEnabled) {
            dispatch(offerReduxActionCreators.updatedDealerMessage(e.target.value));
        }
    };

    return (
        <LoadingSectionParent>
            <InterstateCard
                data-testid="offer-notes-container"
                className="offer-notes-container"
                sx={{
                    '&.offer-notes-container': {
                        borderRadius: '0.625rem!important',
                        boxShadow: (theme) => `${theme.tokens.BaseShadowLg}`
                    }
                }}
                header={
                    <>
                        <CardHeader title={title} data-testid="offer-comments-title" />
                        {description && (
                            <Typography
                                variant="body-md"
                                tag="p"
                                sx={{
                                    // istanbul ignore next
                                    marginBottom: '1.3rem'
                                }}
                            >
                                {description}
                            </Typography>
                        )}
                    </>
                }
                content={
                    <CardContent>
                        <TextArea
                            label=""
                            name="comment"
                            displayLabel={false}
                            disabled={isLocked}
                            value={comment}
                            placeholder="Add comments"
                            rows={textRows}
                            onBlur={handleCommentsChanged}
                            data-testid="offer-comments"
                        />
                    </CardContent>
                }
            />
        </LoadingSectionParent>
    );
};

export default OfferCommentsInterstate;
